import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  makeStyles,
} from '@material-ui/core'
import { selectUserInfo } from 'src/app/slices/userSlice'
import ProfessionalCourseHeader from './ProfessionalCourseHeader'
import BasketCard from './BasketCard'
import {
  selectorProfessionalCourseGroup,
  getProfessionalCoursesGroup,
  getCourseBasket,
  selectorCourseBasket,
} from '../../../app/slices/courseSlice'
import styles from './ProressionalCourse.module.css'

const useStyles = makeStyles({

  surveyBtnWrap: {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
  },
  totalBtn: {
    backgroundColor: '#e6332a',
    width: '150px',
    height: '40px',
    borderRadius: '20px',
    color: '#fff',
    textAlign: 'center',
    border: '2px solid #e6332a',
    fontWeight: '600',
    display: 'flex',
    marginLeft: '20px ',
    marginBottom: '20px',
    '&:hover': {
      backgroundColor: '#e6332a',
      boxShadow: '0 2px 6px 0 rgba(197, 0, 0, 0.36)',
      color: '#ffffff',
    },
  },
})

const ProfessionalCourseCard = ({ admin }) => {
  const classes = useStyles()
  const { pathname } = useLocation()
  const dispatch = useDispatch()
  const professionalCources = useSelector(selectorProfessionalCourseGroup)
  const courseBasket = useSelector(selectorCourseBasket)
  const { role } = useSelector(selectUserInfo)

  useEffect(() => {
    dispatch(getProfessionalCoursesGroup())
    dispatch(getCourseBasket())
  }, [])

  return (
    <div>
      {[1].includes(role?.roleId) && <ProfessionalCourseHeader />}

      {/* <ProfessionalCourseHeader /> */}

      <div
        style={{
          width: '100%',
          display: 'flex',
          margin: '0 0 20px 11px',
          color: '#000',
          flexWrap: 'wrap',
        }}
      >
        {professionalCources?.map((item) => {
          const courseChecked = courseBasket?.items
            ?.map((basket) => basket?.courseGroupId === item?.id)
          return (
            <div
              className={styles.basketCardWrap}
              key={item?.id}
            >
              <BasketCard
                course={item}
                courseBasket={courseBasket}
                courseChecked={courseChecked}
                perofessional
              />
            </div>
          )
        })}
      </div>

      {!admin && (
      <Link
        to={`${pathname}/basket`}
      >
        <Button
          className={classes.totalBtn}
        >
          افزودن به سبد خرید
        </Button>
      </Link>
      )}
    </div>
  )
}

export default ProfessionalCourseCard
